<template lang="pug">
  app-modal.modalFila(
    titulo="Verificar Status",
    @closeModal="closeModal"
  )
    template(slot="body")
      p.titulo Status Analise
      div.mt-20
        span {{ conteudoModal.mensagem }}
    template(slot="footer")
      .flex
        el-button.btn(
            type="default",
            size="small",
            @click="closeModal()"
          )
            span.center
              b &nbsp Cancelar
</template>
<script>
import AppModal from '@/components/AppModal'

export default {

  components: {
    AppModal
  },

  props: {
    conteudoModal: {
      required: true,
      type: Object
    }
  },

  methods: {
    closeModal () {
      this.$emit('closeModal')
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.flex {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
}

.titulo {
  font-weight: bold;
}

.mt-20 {
  margin-top: 35px;
}

@media (max-width: 780px) {
  .modalFila {
    position: fixed !important;
    width: 395px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/components/modal/AppModalFilaManutencao.vue